import { useContext,  useState } from 'react';
import * as language from '../constants/languages';
import Plus from '../assets/svg/plus.svg'
import Minus from '../assets/svg/minus.svg'
import { AuthContext } from '../pages/RootPage';
export default function ProductActionSection({ cartQny, productData, cartUnit }) {
	const { getCompanyId, getBranchId, showSnackMessage } = useContext(AuthContext);
	const companyidValue = getCompanyId()
	const branchId = getBranchId()
	const [quantity, setquantity] = useState(cartQny)
	
	// remove the product
	async function removeItem(id) {
		const cart = sessionStorage.getItem('cartItems');
		const cartItems = JSON.parse(cart);
		const elementsIndex = cartItems.customerCartItems.findIndex(element => element.product.productId == id);
		cartItems.customerCartItems.splice(elementsIndex, 1);
		sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
		if (cartItems.customerCartItems.length == 0) {
			sessionStorage.removeItem('cartItems')
		}
		showSnackMessage(language.removedFromCart)
		const event = new CustomEvent('productQtyChange');;
		window.dispatchEvent(event)
		setquantity(0)
	}


	async function quantityPressed(valueAction) {
		let incrementValue
		if (productData.incrementValue == null) {
			incrementValue = 1
		} else {
			incrementValue = productData.incrementValue
		}
		if (valueAction === 'increment') {
			cartAddRemove(productData.productId, 1) //add qny to cart
		} else {
			if (quantity != incrementValue) {
				cartAddRemove(productData.productId, 0) //reduce qny to cart
			} else {
				removeItem(productData.productId);
			}
		}
	}

	async function cartAddRemove(id, action) {
		let incrementValue
		const cart = sessionStorage.getItem('cartItems')
		let cartItems
		if (!cart) {
			cartItems = {
				customerCartItems: [
				],
				branchId: parseInt(branchId),
				companyId: companyidValue
			}
		} else {
			cartItems = JSON.parse(cart);
		}
		if (productData.incrementValue == null) {
			incrementValue = 1
		} else {
			incrementValue = productData.incrementValue
		}
		if (action == 1) { //add to cart
			if (productData.isStockAvailable == true) {
				if (branchId == cartItems.branchId) {
					const elementsIndex = cartItems.customerCartItems.findIndex(element => element.product.productId == id);
					var requiredQty = elementsIndex == -1 ? incrementValue : (cartItems.customerCartItems[elementsIndex].qty + incrementValue);
					if (productData.allowNegativeStock == true || requiredQty <= (productData.stock ?? 0)) {
						if (elementsIndex == -1) {
							cartItems.customerCartItems = [
								...cartItems.customerCartItems,
								{
									product: productData,
									qty: incrementValue,
									variantId: null
								}
							]
						} else {
							cartItems.customerCartItems[elementsIndex] = {
								product: cartItems.customerCartItems[elementsIndex].product,
								qty: cartItems.customerCartItems[elementsIndex].qty + incrementValue,
								variantId: cartItems.customerCartItems[elementsIndex].variantId
							}
						}
						sessionStorage.setItem('cartItems', JSON.stringify(cartItems))
						setquantity(quantity + incrementValue)
						const event = new CustomEvent('productQtyChange', { token: 2 });
						window.dispatchEvent(event)
					} else {
						showSnackMessage(language.cartAddRemove)

					}
				} else {
					showSnackMessage(language.anotherBranch)
				}
			} else {
				showSnackMessage(language.cartAddRemove)
			}
		} else { //remove from cart
			if (branchId == cartItems.branchId) {
				const elementsIndex = cartItems.customerCartItems.findIndex(element => element.product.productId == id);
				if (elementsIndex > -1) {
					var requiredQty = elementsIndex == -1 ? incrementValue : (cartItems.customerCartItems[elementsIndex].qty - incrementValue);
					cartItems.customerCartItems[elementsIndex] = {
						product: cartItems.customerCartItems[elementsIndex].product,
						qty: (requiredQty < 0 ? 0 : requiredQty),
						variantId: cartItems.customerCartItems[elementsIndex].variantId,
					}
					sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
					setquantity(requiredQty)
					const event = new CustomEvent('productQtyChange', { token: 2 })
					window.dispatchEvent(event)
				} else {
					showSnackMessage(language.cartAddRemove)
				}
			} else {
				showSnackMessage(language.anotherBranch)
			}
		}
	}

	// add to cart
	async function addToCart() {
		let incrementValue
		let cartItems
		if (productData.incrementValue == null) {
			incrementValue = 1
		} else {
			incrementValue = productData.incrementValue
		}
		if (productData.isStockAvailable == true) {
			const cartItemsJson = sessionStorage.getItem('cartItems');
			if (cartItemsJson == undefined) {
				cartItems = {
					customerCartItems: [
					],
					branchId: parseInt(branchId),
					companyId: companyidValue
				}
			} else {
				cartItems = JSON.parse(cartItemsJson);
			}
			if (branchId == cartItems.branchId) {
				const elementsIndex = cartItems.customerCartItems.findIndex(element => element.product.productId == productData.productId);
				var requiredQty = elementsIndex == -1 ? incrementValue : (cartItems.customerCartItems[elementsIndex].qty + incrementValue);
				if (productData.allowNegativeStock == true || requiredQty <= (productData.stock ?? 0)) {
					if (elementsIndex == -1) {
						cartItems.customerCartItems = [
							...cartItems.customerCartItems,
							{
								product: productData,
								qty: incrementValue,
								variantId: null
							}
						]
					} else {
						cartItems.customerCartItems[elementsIndex] = {
							product: cartItems.customerCartItems[elementsIndex].product,
							qty: cartItems.customerCartItems[elementsIndex].qty + incrementValue,
							variantId: cartItems.customerCartItems[elementsIndex].variantId
						}
					}
					sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
					const event = new CustomEvent('productQtyChange');
					window.dispatchEvent(event)
					setquantity(requiredQty)
					// showSnackMessage(language.itemAddedTocart)
				} else {
					showSnackMessage(language.cartAddRemove)
				}
			} else {
				showSnackMessage(language.anotherBranch)
			}
		} else {
			showSnackMessage(language.cartAddRemove)
		}
	}

	return (

		<div className='product-details-action-section'>
			{
				quantity === 0 ?
					<div className='cartWrapperActionSection' onClick={() => addToCart()}>
						<p style={{ fontFamily: 'Poppins-Regular', margin: 0, textAlign: 'center' }}>{language.addToBagLabel}</p>
					</div>
					:
					<div className='quantityWrapperActionSection' >
						<div className='quantityIcon' onClick={() => quantityPressed('decrement')}>
							<img src={Minus} size={14} />
						</div>
						<div style={{ marginHorizontal: 10, alignItems: 'center', }}>
							{
								cartUnit != null ?
									<p style={{ fontFamily: 'Poppins-Regular', margin: 0 }}>{quantity} {cartUnit}</p>
									:
									<p style={{ fontFamily: 'Poppins-Regular', margin: 0 }}>{quantity}</p>
							}
						</div>
						<div className='quantityIcon' onClick={() => quantityPressed('increment')}>
							<img src={Plus} size={14} />
						</div>
					</div>
			}
		</div>
	)
}